export const items = [
    {
        label: 'Dla użytkowników',
        items: [
            {
                label: 'Skąpiec radzi',
                href: 'https://www.skapiec.pl/radzi'
            },
            {
                label: 'Najczęściej zadawane pytania',
                href: '/site/doc/4',
                rel: 'nofollow'
            },
            {
                label: 'Jak to działa?',
                href: '/site/doc/3',
                rel: 'nofollow'
            },
            {
                label: 'Twoje zgody',
                href: 'https://zgody.skapiec.pl/',
                rel: 'nofollow'
            },
            {
                label: 'Regulamin',
                href: '/regulamin-uzytkownika',
                rel: 'nofollow'
            },
            {
                label: 'Newsletter',
                href: '/newsletter',
                rel: 'nofollow'
            }
        ]
    },
    {
        label: 'Dla sklepów',
        items: [
            {
                label: 'Dołącz do Skąpiec.pl',
                href: '/dla-sklepow',
                rel: 'nofollow'

            },
            {
                label: 'Panel dla sklepów',
                href: 'https://partner.moneteasy.pl/skapiec',
                rel: 'nofollow'
            },
            {
                label: 'Raport Sklepów 2020',
                href: 'https://ranking.opineo.pl/',
                rel: 'nofollow'
            }
        ]
    },
    {
        label: 'Dla partnerów',
        items: [
            {
                label: 'Program Partnerski',
                href: '/site/doc/402',
                rel: 'nofollow'
            },
            {
                label: 'API Skąpiec',
                href: '/site/doc/400',
                rel: 'nofollow'
            },
            {
                label: 'Panel Programu Partnerskiego',
                href: 'https://partnerzy.skapiec.pl',
                rel: 'nofollow'
            },
            {
                label: 'FAQ - Program Partnerski',
                href: '/site/doc/402/11',
                rel: 'nofollow'
            },
            {
                label: 'Regulamin',
                href: '/regulamin-programu-partnerskiego',
                rel: 'nofollow'
            }
        ]
    },
    {
        label: 'Skąpiec.pl',
        items: [
            {
                label: 'O nas',
                href: '/o-nas',
                rel: 'nofollow'
            },
            {
                label: 'Centrum prasowe',
                href: '/site/doc/200',
                rel: 'nofollow'
            },
            {
                label: 'Praca',
                href: 'https://www.ringieraxelspringer.pl/kariera/oferty-pracy/',
                rel: 'nofollow'
            },
            {
                label: 'Kontakt',
                href: '/kontakt',
                rel: 'nofollow'
            },
            {
                label: 'Gwiazda Jakości Obsługi',
                href: '/lp/gwiazda-jakosci-obslugi',
                rel: 'nofollow'
            }
        ]
    },
    {
        label: 'Dołącz do nas',
        items: [
            {
                label: 'Facebook',
                href: 'https://www.facebook.com/Skapiec',
                target: '_blank',
                rel: 'follow noopener'
            },
            {
                label: 'Instagram',
                href: 'https://www.instagram.com/skapiec_pl/',
                target: '_blank',
                rel: 'follow noopener'
            },
            {
                label: 'Twitter',
                href: 'https://twitter.com/plskapiec',
                target: '_blank',
                rel: 'follow noopener'
            }
        ]
    }
] as {
    label: string;
    items: {
        label: string;
        href: string;
        target: '_blank';
        rel: string;
    }[];
}[];
